import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { SettingsLoader, LoaderSettings } from 'research.web.settings';

import { Settings } from './app/settings';

import { AppModule } from './app/app.module';


if (environment.production) {
  enableProdMode();
}

const settings: LoaderSettings = { file: 'assets/settings.json', variable: '_appSettings' };
const loader = new SettingsLoader(settings);
loader.readTextFile()
  .then((settingsJson: string) => {
    const appSettings = <Settings>JSON.parse(settingsJson);

  })
  .catch(() => { })
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule));



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/main.ts